import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Metamodel } from 'app/model/base/model';
import { HubSpotObjectDataset } from 'app/model/dataset/hub-spot.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { GlobalVariables } from 'app/services/globals';
import { IModel } from 'shell-models-lib';
import { HubSpotLinkedService } from 'app/model/linkedservice/hub-spot.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HubSpotObjectDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                schema: GlobalVariables.enableTableNameSplitForHubspotV2 ? '*' : undefined,
                table: GlobalVariables.enableTableNameSplitForHubspotV2 ? '*' : undefined,
                tableName: '*' // backward compatibility
            }
        }
    }
})
export class HubSpotObjectDatasetAdapter extends TabularTypeDatasetAdapter<HubSpotObjectDataset, Model.DatasetResource> {
    public override async postToModel(dataset: HubSpotObjectDataset): Promise<void> {
        await super.postToModel(dataset);
        const linkedService = dataset?.linkedService as HubSpotLinkedService;
        // Use split table path (schema + table) for v2 linked services
        if (linkedService?.version === 'v2' && dataset.schema != undefined && dataset.table != undefined) {
            // Ensure v2 datasets use schema/table format
            dataset.tableName = undefined;
        }
    }

    protected model(): IModel {
        return HubSpotObjectDataset.MODEL;
    }

    protected async _toResource(dataset: HubSpotObjectDataset): Promise<Model.DatasetResource> {
        // Use split table path (schema + table) if both are defined
        if (dataset.schema != undefined && dataset.table != undefined) {
            return await this._toResourceInternal(dataset, this.model().name, undefined, 'schema', 'table');
        }
        // Default: use tableName
        return await this._toResourceInternal(dataset, this.model().name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: HubSpotObjectDataset): Promise<HubSpotObjectDataset> {
        if (!dataset) {
            dataset = this.model().create<HubSpotObjectDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource?.properties as Model.HubspotObjectDataset;
        
        // Check if backend has split table path format (v2)
        if (model?.typeProperties?.table != undefined && model?.typeProperties?.schema != undefined) {
            // v2 format: read schema and table separately
            ValueAdapter.toModel(dataset, HubSpotObjectDataset.SCHEMA, model.typeProperties.schema);
            ValueAdapter.toModel(dataset, HubSpotObjectDataset.TABLE, model.typeProperties.table);
        } else {
            // Legacy format: read tableName (for v1 or existing v2 datasets)
            ValueAdapter.toModel(dataset, HubSpotObjectDataset.TABLE_NAME, model?.typeProperties?.tableName);
        }
        return dataset;
    }
}
